import { Note, UserLite } from '@card-software/library';
import { AuditTrail } from '@card-software/nexus-models';

export enum RemissionGuideStatus {
  Draft = 0,
  Delivered = 1,
}

export interface NamedDocumentKey {
  reference?: string;
  name?: string;
}

export interface RemissionGuideDto extends AuditTrail {
  id: string;
  number: string;
  status: RemissionGuideStatus;
  issuedDate: string;
  remitterReference: string;
  remitter?: NamedDocumentKey;
  consigneeReference: string;
  consignee?: NamedDocumentKey;
  departurePlaceCode: string;
  destinationPlaceCode: string;
  transferStartDate: string;
  transferEndDate: string;
  remissionGuideTransferTypeCode: string;
  otherTransferTypeDetail?: string;
  lines: RemissionGuideLineDto[];
  transportInfo?: RemissionGuideTransportInfoDto;
  footerMessage?: string;
  notes: Note[];
  statusHistory: RemissionGuideStatusHistoryEntry[];
}

export interface RemissionGuideLineDto {
  id: string;
  itemCode?: string;
  description?: string;
  quantity: number;
  uom: number;
  totalPrice: number;
  grossWeightKg: number;
  netWeightKg: number;
  packageCount: number;
}

export interface RemissionGuideTransportInfoDto {
  carrierName?: string;
  carrierTaxId?: string;
  driverName?: string;
  driverTaxId?: string;
  vehicleId?: string;
  driverLicenseNumber?: string;
  tractorId?: string;
  sealNumber?: string;
  departureTime?: string;
  authorizedByUsername?: string;
}

export interface RemissionGuideStatusHistoryEntry {
  date: string;
  status: RemissionGuideStatus;
  user: UserLite;
  comment?: string;
}
